export default __webpack_public_path__ + "static/media/actividad-43.7bb9e854.mp3";